import dayjs from "dayjs"

export const datesMixin = {
    methods: {
        friendlyShort: function (date) {
            return dayjs(date).format("D MMM")
        },
        friendlyDate: function (date) {
            return dayjs(date).format("D MMM 'YY")
        },
        friendlyDateAndTime: function (date) {
            return dayjs(date).format("D MMM 'YY @ HH:mm")
        },
        friendlyDateFull: function (date) {
            return dayjs(date).format("D MMMM YYYY")
        },
        friendlyDateFullISO: function (date) {
            return dayjs(date).format("YYYY-MM-DD")
        },
        friendlyTime: function (date) {
            return dayjs(date).format("HH:mm")
        },
        friendlyChatTime: function (date) {
            return dayjs(date).format("HH:mm A")
        },
        friendlyChatDateShort: function (date) {
            return dayjs(date).format("MMM D")
        },
        friendlyDayOfWeek: function (date) {
            switch (dayjs(date).day()) {
                case 0:
                    return "Sunday";
                case 1:
                    return "Monday";
                case 2:
                    return "Tuesday";
                case 3:
                    return "Wednesday";
                case 4:
                    return "Thursday";
                case 5:
                    return "Friday";
                case 6:
                default:
                    return "Saturday";
            }
        },
        smartTimeOrDate: function (date) {
            const dateToDisplay = dayjs(date);
            const startOfToday = dayjs().startOf("day");
            const dayAgo = startOfToday.subtract(1, "day");
            const sixDaysAgo = startOfToday.subtract(6, "day");
            if (dateToDisplay.isAfter(startOfToday)) {
                return this.friendlyTime(date);
            } else if (dateToDisplay.isAfter(dayAgo)) {
                return "Yesterday";
            } else if (dateToDisplay.isAfter(sixDaysAgo)) {
                return this.friendlyDayOfWeek(date);
            } else {
                return this.friendlyDateFullISO(date);
            }
        },
        creditCardExpiry: function (date) {
            return dayjs(date).format("M/YYYY")
        },
    }
};